import { ICON_TYPES } from './iconTypes';

export default {
	video: {
		name: 'video-outline',
		type: ICON_TYPES.materialCommunityIcons,
		text: 'Video',
	},
	videoOff: {
		name: 'video-off',
		type: ICON_TYPES.materialCommunityIcons,
		text: 'Mute Video',
	},
	microphone: {
		name: 'microphone',
		type: ICON_TYPES.fontAwesome,
		text: 'Microphone',
	},
	microphoneOff: {
		name: 'microphone-slash',
		type: ICON_TYPES.fontAwesome,
		text: 'Mute',
	},
	volume: {
		name: 'ios-volume-high',
		type: ICON_TYPES.ionicon,
		text: 'Sound',
	},
	volumeOff: {
		name: 'md-volume-mute',
		type: ICON_TYPES.ionicon,
		text: 'Mute',
	},
	videoCall: {
		name: 'video-call',
		type: ICON_TYPES.materialIcons,
		text: 'Call'
	},
	call: {
		name: 'phone',
		type: ICON_TYPES.fontAwesome5,
		text: 'Call',
	},
	endCall: {
		name: 'phone-slash',
		type: ICON_TYPES.fontAwesome5,
		text: 'End',
	},
	cameraRetake: {
		name: 'camera-retake',
		type: ICON_TYPES.materialCommunityIcons,
		text: 'Retake',
	},
	cameraReverse: {
		name: 'camera-reverse',
		type: ICON_TYPES.ionicon,
		text: 'Switch',
	},
	flipCamera: {
		name: 'flip-camera-android',
		type: ICON_TYPES.materialIcons,
		text: 'Switch',
	},
	flashOn: {
		name: 'flash',
		type: ICON_TYPES.ionicon,
		text: 'Flash On',
	},
	flashOff: {
		name: 'flash-off',
		type: ICON_TYPES.ionicon,
		text: 'Flash Off',
	},
	camera: {
		name: 'camera',
		type: ICON_TYPES.ionicon,
		text: 'Camera',
	},
	cameraPlus: {
		name: 'camera-plus',
		type: ICON_TYPES.materialCommunityIcons,
		text: 'New',
	},
	circleOutline: {
		name: 'circle-outline',
		type: ICON_TYPES.materialCommunityIcons,
		text: 'circleOutline',
	},
	ghost: {
		name: 'ghost',
		type: ICON_TYPES.materialCommunityIcons,
		text: 'Ghost',
	},
	ghostOff: {
		name: 'ghost-off',
		type: ICON_TYPES.materialCommunityIcons,
		text: 'Hide',
	},
	accountCancel: {
		name: 'account-cancel',
		type: ICON_TYPES.materialCommunityIcons,
		text: 'Cancel',
	},
	screenShare: {
		name: 'screen-share',
		type: ICON_TYPES.materialIcons,
		text: 'Share',
	},
	screenShareStop: {
		name: 'stop-screen-share',
		type: ICON_TYPES.materialIcons,
		text: 'Stop',
	},
	dictationStart: {
		name: 'record-voice-over',
		type: ICON_TYPES.materialIcons,
		text: 'Voice',
	},
	dictationStop: {
		name: 'record-circle',
		type: ICON_TYPES.materialCommunityIcons,
		text: 'Stop',
	},
};